<script setup>
import { storeToRefs } from 'pinia'
import { ref, onMounted, watch, inject } from 'vue'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import learningApiUser from '@src/services/api/learning/user'
import { useLearningUserStore } from '@stores/user'
import { useLearningAuthStore } from '@stores/auth'
import axios from 'axios'
import QRCodeVue3 from 'qrcode-vue3'

const router = useRouter()
const rootAppProvide = inject('rootAppProvide')
const { accessToken } = storeToRefs(useLearningAuthStore())

const props = defineProps({
  courseId: {
    type: String,
    required: true
  }
})
const detail = ref(null)
const keywords = ref([])
const questionnaire = ref([])

// 予約講座詳細取得
const getDetail = () => {
  rootAppProvide.value.openContentsLoading()
  console.log('props.courseId', props.courseId)
  learningApiUser.getTraineeDetail({
    params: {
      with: 'course.location'
    },
    custom: {
      params: { traineeId: props.courseId }
    }
  }).then((res) => {
    console.log('res', res.data)
    detail.value = res.data
    if (res.data.course.questionnaire?.length > 0) {
      questionnaire.value = res.data.course.questionnaire.map(() => '')
    }
  }).catch((err) => {
    console.error('getDetail err', err)
  }).finally(() => {
    rootAppProvide.value.closeContentsLoading()
  })
}

onMounted(async () => {
  console.log('courseDetail')
  getDetail()
})
</script>

<template>
  <div class="container">
    <h2>【受講票・申込詳細】</h2>
    <div
      v-if="detail"
      class="detail"
    >
      <table class="cardTable">
        <tr>
          <th>受講票No</th>
          <td>{{ detail.no }}</td>
        </tr>
        <tr>
          <th>座席No</th>
          <td>{{ detail.seat }}</td>
        </tr>
        <tr>
          <th>開催日時</th>
          <td>
            {{ dayjs(detail.course.term[0]).format('YYYY/MM/DD(dd) HH:mm') }}～{{ dayjs(detail.course.term[1]).format('YYYY/MM/DD(dd) HH:mm') }}
          </td>
        </tr>
        <tr>
          <th>申込日</th>
          <td>{{ dayjs(detail.created_at).format('YYYY/MM/DD(dd) HH:mm') }}</td>
        </tr>
        <tr>
          <th>会場</th>
          <td>{{ detail.course.location.displays.name }}</td>
        </tr>
        <tr>
          <th>出欠</th>
          <td>{{ detail.attendance === null ? '受講前' : detail.attendance === true ? '出席' : '欠席' }}</td>
        </tr>
        <tr>
          <th>終了証明書ID</th>
          <td>{{ detail.certificate_id ? detail.certificate_id : '-' }}</td>
        </tr>
        <tr>
          <th>ご案内</th>
          <td>{{ detail.guidance }}</td>
        </tr>
      </table>
      <div class="qrcode">
        <QRCodeVue3
          :width="200"
          :height="200"
          :value="detail.no"
          :dotsOptions="{ color: '#000' }"
          :cornersSquareOptions="{ type: 'square', color: '#000000' }"
          fileExt="png"
          myclass="my-qur"
          imgclass="img-qr"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  margin-top: -131px;
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }

  .detail {
    width: 100%;

    table.cardTable {
      width: 100%;
      border-top: 1px solid #000;
      border-left: 1px solid #000;

      th {
        width: 200px;
        height: 100%;
        padding: 8px 15px 10px;
        background: #eaeaea;
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        font-size: 16px;
        text-align: right;
      }
      
      td {
        width: calc(100% - 200px);
        padding: 8px 15px 10px;
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        font-size: 16px;

        button {
          display: inline-block;
          width: auto;
          padding: 3px 8px;
          vertical-align: 1px;
          margin: 8px 10px 0 0;
        }
      }
    }
  }
}
.qrcode {
  margin-top: 30px;
  width: 200px;
  height: 200px;
}
</style>
